import React from 'react'
import { Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const llmLabel = {
  gpt: 'OpenAI GPT',
  gemini: 'Google Gemini',
  google_ai_mode: 'Google AI Mode',
  perplexity: 'Perplexity',
  claude: 'Claude',
  copilot: 'Copilot',
}

const nodeLabel = {
  questions: 'Domande',
  answers: 'Risposte',
  analysis: 'Analisi',
  final_views: 'Viste finali',
}

const statusLabel = {
  completed: 'Completato',
  incomplete: 'Incompleto',
  failed: 'Fallito',
}

const statusClass = {
  completed: 'llm-resume-flow-modal__node--completed',
  incomplete: 'llm-resume-flow-modal__node--incomplete',
  failed: 'llm-resume-flow-modal__node--failed',
}

const branchOrder = ['answers', 'analysis', 'final_views']

const LLMResumeFlowModal = ({
  isOpen,
  toggle,
  flowStatus,
  loading,
  onRefresh,
  onResumeNode,
  runningNodeKey = '',
}) => {
  const renderNode = (llm, nodeKey, nodeData) => {
    const status = nodeData?.status || 'incomplete'
    const resumeEnabled = Boolean(nodeData?.resume_enabled)
    const resumeReason = nodeData?.resume_reason || ''
    const currentKey = llm ? `${llm}:${nodeKey}` : nodeKey
    const isRunning = runningNodeKey === currentKey

    return (
      <div key={currentKey} className={`llm-resume-flow-modal__node ${statusClass[status] || ''}`}>
        <div className="llm-resume-flow-modal__node-head">
          <span className="llm-resume-flow-modal__node-name">{nodeLabel[nodeKey] || nodeKey}</span>
          <span className="llm-resume-flow-modal__node-status">{statusLabel[status] || status}</span>
        </div>
        {llm && status !== 'completed' && (
          <button
            className="llm-resume-flow-modal__resume-btn"
            disabled={!resumeEnabled || isRunning}
            onClick={() => onResumeNode(llm, nodeKey)}
            title={resumeEnabled ? 'Riprendi da questo nodo' : resumeReason}
            type="button"
          >
            {isRunning ? (
              <>
                <Spinner animation="border" size="sm" className="mr-1" /> Ripresa...
              </>
            ) : (
              <>
                <i className="ni ni-button-play mr-1" />
                Riprendi
              </>
            )}
          </button>
        )}
        {llm && status !== 'completed' && !resumeEnabled && resumeReason && (
          <small className="llm-resume-flow-modal__node-reason">{resumeReason}</small>
        )}
      </div>
    )
  }

  const branchEntries = Object.entries(flowStatus?.branches || {}).sort(([left], [right]) =>
    (llmLabel[left] || left).localeCompare(llmLabel[right] || right)
  )

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <ModalHeader toggle={toggle}>Riprendi flusso LLM per nodo</ModalHeader>
      <ModalBody className="llm-resume-flow-modal">
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" role="status">
              <span className="sr-only">Caricamento stato...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <div className="llm-resume-flow-modal__legend">
              <span className="llm-resume-flow-modal__legend-item llm-resume-flow-modal__legend-item--completed">Verde: completato</span>
              <span className="llm-resume-flow-modal__legend-item llm-resume-flow-modal__legend-item--incomplete">Giallo: incompleto</span>
              <span className="llm-resume-flow-modal__legend-item llm-resume-flow-modal__legend-item--failed">Rosso: fallito</span>
            </div>

            <div className="llm-resume-flow-modal__questions">
              {renderNode(null, 'questions', flowStatus?.questions)}
            </div>

            {branchEntries.length === 0 ? (
              <div className="text-muted text-center py-3">Nessun LLM attivo configurato su questa esecuzione.</div>
            ) : (
              <div className="llm-resume-flow-modal__branches">
                {branchEntries.map(([llm, branch]) => (
                  <div key={llm} className="llm-resume-flow-modal__branch">
                    <div className="llm-resume-flow-modal__branch-title">{llmLabel[llm] || llm.toUpperCase()}</div>
                    <div className="llm-resume-flow-modal__path">
                      {branchOrder.map((nodeKey) => renderNode(llm, nodeKey, branch?.[nodeKey]))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} type="button">
          Chiudi
        </Button>
        <Button color="info" onClick={onRefresh} type="button">
          Aggiorna stato
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default LLMResumeFlowModal
